// core
import React from 'react';
import { Link } from 'react-router-dom'

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';

// lib
import Page from 'pages/shared/Page';
import Spinner from 'components/shared/Spinner';

// shared
import PageHeader from 'components/shared/PageHeader';
import ButtonsToolbar from 'components/shared/ButtonsToolbar';
import FiltersToolbar from 'components/shared/filters/FiltersToolbar';
import SortingToolbar from 'components/shared/SortingToolbar';

import MainHeading from 'components/shared/MainHeading';
import PageDataWrapper from 'pages/shared/PageDataWrapper.js';

class ListOverviewPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      status: {
        fetching: false
      },

      errors: [],

      surveys: []
    };
  }

  componentDidMount() {
    this.setState(({
      fetching: true
    }));

    API.call('GET', Settings.V2_API_URL + '/surveys', {}, (response, error) => {
      if (error) {
        console.dir(error);

        this.setState((prevState) => {
          prevState.errors.push({
            message: 'cannot get surveys: ' + error.message
          });

          return prevState;
        });

        return false;
      }

      this.setState({
        fetching: false,

        surveys: response.data && response.data.surveys ? response.data.surveys : []
      });
    });
  }

  render() {
    var surveys = this.state.surveys.map((survey) => {
      return (
        <p><Link to={'/marketing/surveys/' + survey.id + '/view/'}>{survey.title}</Link> - <small>il {survey.updated_at}{survey.product_id ? ' in ' + survey.product_id : ''}</small></p>
      );
    });

    return (
      <div>
        <PageHeader>
          <ButtonsToolbar
            related={[
              {
                label: 'Crea nuovo',
                href: '/marketing/surveys/new/',
                type: 'add'
              }
            ]}
          />
          <MainHeading
            icon=""
            title="Sondaggi"
            descr=""
          />
        </PageHeader>

        <PageDataWrapper
          appData={this.props.appData}

          data={{
            label: 'Tutti i sondaggi',
            descr: '(' + this.state.surveys.length + ')',
            onExport: this.state.surveys.length && 0 ? () => {
              alert('export!');
            } : null
          }}
          status={{
            fetching: this.state.fetching,
            errors: this.state.errors
          }}
        >
          {surveys}
        </PageDataWrapper>
      </div>
    );
  }
}

export default ListOverviewPage;


// WEBPACK FOOTER //
// ./src/pages/marketing/recipients/ListOverviewPage.js